import {
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
} from "@material-ui/core";
import numeral from "numeral";
import { useEffect, useState } from "react";

import { getRequest } from "../../../api/apiCaller";
import Dialog from "../../../components/Dialog";
import API_URL from "../../../constant/api-url";
import datetimeHelper from "../../../helper/datetime-helper";
import DataNotFound from "./DataNotFound";
import classes from "./TableReportCalls.module.css";

const TableReportCalls = ({ reportCallsFilter }) => {
  const { switchboardGroup } = reportCallsFilter;
  const COLUMNS = [
    {
      name: "Ngày",
      customValue: (row) =>
        datetimeHelper.toFormat(row.startedAt, "YYYY-MM-DD"),
      width: 100,
    },
    {
      id: "subOrg",
      name: "Mã bưu cục",
      width: 75,
    },
    {
      id: "subOrgName",
      name: "Tên bưu cục",
      width: 200,
    },
    {
      id: "pbxType",
      name: "Nhóm tổng đài",
    },
    {
      name: "Số gọi vào",
      customValue: () => "-", // TODO làm sau
    },
    {
      id: "from",
      name: "Đầu số MST gọi ra",
    },
    {
      name: "Mạng",
      customValue: (row) => getLabelMNP(row.mnpFrom),
      width: 75,
    },
    {
      name: "Số máy lẻ gọi ra",
      customValue: (row) => row.extension?.name || "",
    },
    {
      name: "Tài khoản gọi ra",
      customValue: (row) =>
        row.agent?.user?.fullname || row.agent?.user?.username || "",
    },
    {
      id: "to",
      name: "Số điện thoại nhận",
    },
    {
      name: "Mạng nhận",
      customValue: (row) => getLabelMNP(row.mnpTo),
      width: 75,
    },
    {
      name: "Thời gian bắt đầu",
      customValue: (row) =>
        datetimeHelper.toFormat(row.startedAt, "YYYY-MM-DD HH:mm:ss"),
    },
    {
      name: "Thời gian kết thúc",
      customValue: (row) =>
        datetimeHelper.toFormat(row.endedAt, "YYYY-MM-DD HH:mm:ss"),
    },
    {
      id: "answeredDuration",
      name: "Thời lượng (giây)",
    },
    {
      id: "answeredDurationMinute",
      name: "Thời lượng (phút)",
    },
    {
      name: "Loại cuộc gọi",
      customValue: (row) => getLabelNetwork(row.network),
    },
    {
      name: "Cước tạm tính",
      customValue: (row) => numeral(row.totalprice).format("0,0.00"),
    },
  ];

  const [reportCallsData, setReportCallsData] = useState(null);
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(10);
  const [total, setTotal] = useState(0);
  const [where, setWhere] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const getReportOutbound = async () => {
    setIsLoading(true);
    getRequest(`${API_URL.CLOUD_PBX_OUTBOUND_CALL}/count`, {
      where: {
        ...where,
        status: "answered",
      },
      ...(switchboardGroup && { type: switchboardGroup }),
    }).then((res) => setTotal(res.data?.count || 0));

    getRequest(API_URL.CLOUD_PBX_OUTBOUND_CALL, {
      filter: {
        order: "startedAt DESC",
        limit: size,
        skip: page * size,
        where: {
          ...where,
          status: "answered",
        },
      },
      ...(switchboardGroup && { type: switchboardGroup }),
    })
      .then((res) => {
        setReportCallsData(res.data);
        setIsLoading(false);
      })
      .catch(() => setIsLoading(false));
  };

  const renderTableCellValue = (row, column) => {
    let value = column.customValue
      ? column.customValue(row, column)
      : row[column.id];
    return value;
  };

  useEffect(() => {
    const pageFilter = reportCallsFilter?.page;
    const whereFilter = reportCallsFilter?.where;
    if (pageFilter !== null && pageFilter !== undefined) setPage(pageFilter);
    if (whereFilter) setWhere(whereFilter);
  }, [reportCallsFilter]);

  useEffect(() => {
    if (where !== null) {
      getReportOutbound();
    }
  }, [page, size, where]);

  const handleChangePage = (_event, newPage) => {
    setPage(newPage);
  };

  const handleChangeSize = (event) => {
    const newSize = event.target.value;
    setSize(newSize);
    setPage(0);
  };

  const getLabelMNP = (mnp) => {
    const mnpLabel = {
      viettel: "viettel",
      gpc: "vinaphone",
      vms: "mobiphone",
      vnm: "vietnamobile",
      gtel: "gmobile",
      itel: "itel",
      fixed: "fixed",
      other: "other",
    };
    return mnpLabel[mnp] || mnp;
  };

  const getLabelNetwork = (network) => {
    const networkLabel = {
      "on-net": "Nội mạng",
      "off-net": "Ngoại mạng",
    };
    return networkLabel[network] || network;
  };

  return (
    <>
      {reportCallsData && (
        <Paper style={{ color: "black", padding: 16 }}>
          {reportCallsData.length > 0 && (
            <>
              <div className={classes.tableContainer}>
                <Table className={classes.table}>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        align="center"
                        style={{ width: 60 }}
                        className={classes.tableBodyCell}>
                        STT
                      </TableCell>
                      {COLUMNS.map((column, key) => (
                        <TableCell
                          key={key}
                          align={column.align}
                          style={{ width: column.width }}
                          className={classes.tableBodyCell}>
                          {column.name}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {reportCallsData.map((row, columnIndex) => (
                      <TableRow key={columnIndex}>
                        <TableCell
                          align="center"
                          className={classes.tableBodyCell}>
                          {page * size + columnIndex + 1}
                        </TableCell>
                        {COLUMNS.map((column, cellIndex) => (
                          <TableCell
                            key={cellIndex}
                            align={column.align}
                            className={classes.tableBodyCell}
                            style={{ width: column.width }}>
                            {renderTableCellValue(row, column)}
                          </TableCell>
                        ))}
                      </TableRow>
                    ))}
                    <TableRow>
                      <TableCell colSpan={3} className={classes.tableBodyCell}>
                        Tổng cộng
                      </TableCell>
                      <TableCell className={classes.tableBodyCell}>
                        Số cuộc gọi
                      </TableCell>
                      <TableCell
                        colSpan={COLUMNS.length + 1 - 4}
                        className={classes.tableBodyCell}>
                        {total}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </div>
              <TablePagination
                rowsPerPageOptions={[10, 20, 50]}
                component="div"
                count={total}
                rowsPerPage={size}
                page={page}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeSize}
              />
            </>
          )}

          {reportCallsData.length === 0 && <DataNotFound />}
        </Paper>
      )}
      {<Dialog open={isLoading} title={<CircularProgress />} />}
    </>
  );
};

export default TableReportCalls;
